import axios from 'axios'
import config from './config'

const request = axios.create({
  baseURL: config.baseURL,
  timeout: config.timeout
})

// 添加请求拦截器
request.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 添加响应拦截器
request.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  return response
}, function (error) {
  // 对响应错误做点什么
  let errorMsg
  const errorInfo = error.config
  switch (error.request.status) {
    case 404:
      errorMsg = errorInfo.url + '：接口不存在'
      break
    default:
      errorMsg = error
      break
  }
  return Promise.reject(errorMsg)
})

export default request



// WEBPACK FOOTER //
// ./src/utils/request.js